import React from "react";
import { Sparkles, Lock } from "lucide-react";

export default function ModulePlaceholder({ title, description, icon: Icon = Sparkles, testKey }) {
  const tid = testKey || title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  return (
    <div className="space-y-6 page-enter" data-testid={`module-${tid}-placeholder`}>
      <div className="rounded-3xl bg-gradient-to-br from-brand-sky to-blue-700 text-white p-8 sm:p-10">
        <div className="flex items-center gap-2 text-white/80 text-xs uppercase tracking-wider font-bold">
          <Sparkles className="w-3.5 h-3.5"/> Premium module
        </div>
        <div className="flex items-start gap-4 mt-4">
          <div className="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center shrink-0">
            <Icon className="w-7 h-7"/>
          </div>
          <div>
            <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
            <p className="text-white/85 mt-2 max-w-xl leading-relaxed">{description}</p>
          </div>
        </div>
        <div className="mt-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 text-xs font-bold uppercase tracking-wider">
          <Lock className="w-3.5 h-3.5"/> Coming soon
        </div>
      </div>
    </div>
  );
}
